module.exports = __webpack_public_path__ + "media/Nao.ff3613ac.mp3";